export const getStepData = (stepsData, stepName, key) => {
  if (key) return stepsData[stepName] ? stepsData[stepName][key] : void 0;
  return stepsData[stepName];
};
export const getNextStep = (orderedSteps, activeStep) => {
  const activeStepIndex = orderedSteps.indexOf(activeStep);
  if (activeStepIndex < 0) return void 0;
  return orderedSteps[activeStepIndex + 1];
};
export const checkHasNextStep = (orderedSteps, activeStep) => {
  const nextStep = getNextStep(orderedSteps, activeStep);
  return !!nextStep;
};
export const checkHasPreviousStep = (orderedSteps, activeStep) => {
  if (orderedSteps.length === 0 || !activeStep) return false;
  const activeStepIndex = orderedSteps.indexOf(activeStep);
  if (activeStepIndex === -1) return false;
  if (activeStepIndex === 0) return false;
  return true;
};
export const updateStepData = (stepsData, stepName, data, override = false) => {
  if (override) {
    return { ...stepsData, [stepName]: data };
  }
  return { ...stepsData, [stepName]: { ...stepsData[stepName], ...data } };
};
